import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/users")({
  head: () => ({
    meta: [
      { title: "Customer management · Landoo Super Admin" },
      { name: "description", content: "Customer management — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Customer management" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Customer management"
        description="Super admin management surface for Customer management."
      />
    </DashboardShell>
  ),
});
